// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: 0,
  },
  mutations: {
    setScreenWidth(state, screenWidth) {
      state.screenWidth = screenWidth
    }
  },
})